import { gql } from "@apollo/client";

export const GET_INSTANCE_BY_ID_QUERY = gql`
  query InstanceById($id: String) {
    instanceById(id: $id) {
      _id
      file_name
      metadata
      annotations
      orientation
      modality
      validated
      measurements
      creation_date
      vertebra
      has_t_13
      has_s1_lumbarized
      has_l5_sacralized
      functional_handplate
      display_settings
    }
  }
`;

export const GET_INSTANCES_BY_IDS_QUERY = gql`
  query InstancesByIds($ids: [String]) {
    instancesByIds(ids: $ids) {
      _id
      file_name
      modality
      annotations
      orientation
      validated
      creation_date
      tenant_id
      patient_id
      measurements
      vertebra
      has_t_13
      has_s1_lumbarized
      has_l5_sacralized
      functional_handplate
      display_settings
    }
  }
`;
